import React, { useEffect, useState } from 'react';

import {
  headersOrdemCompra,
  valoresExibidosFiscalContrato,
} from './auxiliarOrdemCompra';
import BarraInferiorBotoes from '../../../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CheckboxCustomizado from '../../../../../../../components/CheckBoxCustomizado';
import CustomButton from '../../../../../../../components/CustomButton';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import Input from '../../../../../../../components/InputNew';
import SelectInput from '../../../../../../../components/InputNew/Select';
import Select from '../../../../../../../components/InputNew/Select';
import Log from '../../../../../../../components/Log/Log';
import Modal from '../../../../../../../components/Modal';
import Tabela from '../../../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import { useStatusOrdemCompra } from '../../../../../../../services/enum/useStatusOrdemCompra';
import httpClient, {
  isHttpError,
} from '../../../../../../../services/httpClient';
import { getCotacaoPorTermoReferencia } from '../../../../../../../services/orgInters/orgInterCotacaoService';
import { getOrdemCompraPorTermoReferencia } from '../../../../../../../services/orgInters/orgInterOrdemCompraService';
import { getProdutoPorPlanoTrabalho } from '../../../../../../../services/orgInters/orgInterPlanoTrabalhoService';
import { getProdutoDAFSimples } from '../../../../../../../services/produtosDAF/produtosDafService';
import theme from '../../../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatarNumero,
  formatarValorFormatoDinheiro,
  formatDate,
  formatDateSimp,
  parseInputMonetario,
} from '../../../../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../../../utils/swal';
import { useOrgInterDadosGerais } from '../../context/dadosGeraisContext';

interface Props {
  termoRefId: number;
}

type CotacaoDataType = {
  cotacaoId: number;
  identificacao: string;
  cotacaoNumeracao: string;
  produtoId: number;
  produtoFarmaceutico: string;
  valorUnitario: number;
  cambio: number;
};

type OrdemCompraType = {
  id: number;
  usuarioId: number;
  orgInterId: number;
  termoRefId: number;
  cotacaoId: number;
  produtoId: number;
  statusOrdem: number;
  numeracaoReq: string;
  numeracaoOrdem: string;
  embalagemFator: string;
  qtdEncomendada: string;
  dataOrdem: string;
  dataPrevisao: string;
  qtdEmbalagens: string;
  valorUnitarioDolar: string;
  cambio: string;
  valorTotalDolares: string;
  valorTotalReais: string;
  observacoes: string;
};

const OrdemCompra: React.FC<Props> = ({ termoRefId }) => {
  const { orgInter, userID } = useOrgInterDadosGerais();
  //////ENUMS
  const statusOrdemOptions = useStatusOrdemCompra();

  //////STATES
  const [showModal, setShowModal] = useState(false);
  const [showModalFormCotacao, setShowModalFormCotacao] = useState(false);
  const [logData, setLogData] = useState<any>();
  const [recordId, setRecordId] = useState('');
  const [updating, setUpdating] = useState(false);
  const [data, setData] = useState<any[]>();
  const [form, setForm] = useState<OrdemCompraType>({
    id: 0,
    usuarioId: userID,
    orgInterId: orgInter,
    termoRefId: termoRefId,
    cotacaoId: 0,
    produtoId: 0,
    statusOrdem: 0,
    numeracaoReq: '',
    numeracaoOrdem: '',
    embalagemFator: '',
    qtdEncomendada: '',
    dataOrdem: '',
    dataPrevisao: '',
    qtdEmbalagens: '',
    valorUnitarioDolar: '',
    cambio: '',
    valorTotalDolares: '',
    valorTotalReais: '',
    observacoes: '',
  });
  const [formCotacao, setFormCotacao] = useState<CotacaoDataType>({
    identificacao: '',
    cotacaoId: 0,
    cotacaoNumeracao: '',
    produtoId: 0,
    produtoFarmaceutico: '',
    valorUnitario: 0,
    cambio: 0,
  });
  const [produtoData, setProdutoData] = useState<
    { value: number; label: string }[]
  >([]);
  const [produtoAllData, setProdutoAllData] = useState<
    { value: number; label: string }[]
  >([]);
  const [cotacoesData, setCotacoesData] = useState<CotacaoDataType[]>([]);

  //////VARIÁVEIS TEMPORÁRIAS
  const [tempCotacaoId, setTempCotacaoId] = useState(0);
  const [tempCotacaoReq, setTempCotacaoReq] = useState('');
  const [tempProdutoId, setTempProdutoId] = useState(0);
  const [tempValorUnitario, setTempValorUnitario] = useState(0);
  const [tempCambio, setTempCambio] = useState(0);
  const [isPlanoTrabalho, setIsPlanoTrabalho] = useState(true);

  //////FETCH DATA
  const fetchMain = async () => {
    try {
      const records = await getOrdemCompraPorTermoReferencia(
        String(termoRefId),
      );
      setData(records);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };
  const fetchCotacoes = async () => {
    try {
      const cotacoes = await getCotacaoPorTermoReferencia(String(termoRefId));
      setCotacoesData(cotacoes);
    } catch (error: any) {
      if (isHttpError(error)) {
        console.log(error.response?.data.message);
      }
    }
  };
  const fetchProdutos = async () => {
    try {
      const produtos = await getProdutoPorPlanoTrabalho(String(orgInter));
      const produtosAll = await getProdutoDAFSimples();

      setProdutoData([
        { value: 0, label: 'Não informado' },
        ...produtos.map(
          (item: { id: number; produtoFarmaceutico: string }) => ({
            value: item.id,
            label: item.produtoFarmaceutico,
          }),
        ),
      ]);

      setProdutoAllData([
        { value: 0, label: 'Não informado' },
        ...produtosAll.map(
          (item: { id: number; produtoFarmaceutico: string }) => ({
            value: item.id,
            label: item.produtoFarmaceutico,
          }),
        ),
      ]);
    } catch (error) {
      console.error('Erro ao obter produtos:', error);
      setProdutoData([]);
    }
  };
  useEffect(() => {
    fetchMain();
    fetchProdutos();
    fetchCotacoes();
  }, []);

  const cotacoesOptions = [
    { value: 0, label: 'Não informado' },
    ...cotacoesData.map((item) => ({
      value: item.cotacaoId,
      label: item.identificacao,
    })),
  ];

  //////TABLE E OFFCANVAS
  const tableData =
    data
      ?.slice()
      .sort(
        (a, b) =>
          new Date(a.dataOrdem).getTime() - new Date(b.dataOrdem).getTime(),
      )
      .map((item) => {
        // Definindo cores de fundo com base no status do documento
        let statusBackgroundColor = '';
        let colorText = 'black';

        const statusLabel = statusOrdemOptions[item.statusOrdem].label;

        if (statusLabel === 'Em Elaboração') {
          statusBackgroundColor = theme.colors.amarelogov;
          colorText = 'white';
        } else if (statusLabel === 'Ordem Criada') {
          statusBackgroundColor = theme.colors.azulgov;
          colorText = 'white';
        } else if (statusLabel === 'Ordem Executada') {
          statusBackgroundColor = theme.colors.verdegov;
          colorText = 'white';
        } else if (statusLabel === 'Suspenso') {
          statusBackgroundColor = theme.colors.laranja;
          colorText = 'white';
        } else if (statusLabel === 'Cancelado') {
          statusBackgroundColor = theme.colors.vermelho;
          colorText = 'white';
        }

        return {
          id: item.id,
          statusOrdem: (
            <span
              style={{
                backgroundColor: statusBackgroundColor,
                color: colorText,
                borderRadius: '10px',
                padding: '12px',
                display: 'inline-block',
                minWidth: '100px',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              {statusLabel}
            </span>
          ),
          numeracaoReq: item.cotacao.numeracaoReq,
          numeracaoOrdem: item.numeracaoOrdem,
          produtoDAF: item.produtoDAF.produtoFarmaceutico,

          qtdEncomendada: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarNumero(item.qtdEncomendada)}
            </span>
          ),
          valorTotalReais: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorTotalReais)}
            </span>
          ),
        };
      }) || [];

  const offCanvasData =
    data?.map((item) => {
      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        separadorCotacao: '',
        observacoes: item.observacoes,
      };
    }) || [];

  //////FUNÇÕES HANDLE
  const handleClearForm = () => {
    setForm({
      id: 0,
      usuarioId: userID,
      orgInterId: orgInter,
      termoRefId: termoRefId,
      cotacaoId: 0,
      produtoId: 0,
      statusOrdem: 0,
      numeracaoReq: '',
      numeracaoOrdem: '',
      embalagemFator: '',
      qtdEncomendada: '',
      dataOrdem: '',
      dataPrevisao: '',
      qtdEmbalagens: '',
      valorUnitarioDolar: '',
      cambio: '',
      valorTotalDolares: '',
      valorTotalReais: '',
      observacoes: '',
    });
    setLogData({
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleShowModal = () => setShowModal((prev) => !prev);
  const handleShowModalFormCotacao = () =>
    setShowModalFormCotacao((prev) => !prev);

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdating(false);
    handleShowModalFormCotacao();
  };

  const handleRowClickRow = (id: string) => {
    setRecordId(id);
    setUpdating(true);
    setShowModal(true);

    const itemSelecionado = data?.find((d) => d.id === id);
    if (itemSelecionado) {
      const dataOrdem = itemSelecionado.dataOrdem
        ? new Date(itemSelecionado.dataOrdem).toISOString().split('T')[0]
        : '';

      const dataPrevisao = itemSelecionado.dataPrevisao
        ? new Date(itemSelecionado.dataPrevisao).toISOString().split('T')[0]
        : '';

      setForm({
        id: itemSelecionado.id,
        usuarioId: userID, // você já tem isso no escopo
        orgInterId: orgInter, // também está no escopo do componente
        termoRefId: termoRefId,
        cotacaoId: itemSelecionado.cotacao.id,
        produtoId: itemSelecionado.produtoDAF.id,
        statusOrdem: Number(itemSelecionado.statusOrdem),
        numeracaoReq: itemSelecionado.cotacao.numeracaoReq,
        numeracaoOrdem: itemSelecionado.numeracaoOrdem,
        embalagemFator: formatarNumero(itemSelecionado.embalagemFator),
        qtdEncomendada: formatarNumero(itemSelecionado.qtdEncomendada),
        dataOrdem: dataOrdem,
        dataPrevisao: dataPrevisao,
        qtdEmbalagens: formatarNumero(itemSelecionado.qtdEmbalagens),
        valorUnitarioDolar: formatarValorFormatoDinheiro(
          itemSelecionado.cotacao.valorUnitario,
        ),
        cambio: formatarValorFormatoDinheiro(
          itemSelecionado.cotacao.cotacaoDolar,
        ),
        valorTotalDolares: formatarValorFormatoDinheiro(
          itemSelecionado.valorTotalDolares,
        ),
        valorTotalReais: formatarValorFormatoDinheiro(
          itemSelecionado.valorTotalReais,
        ),
        observacoes: itemSelecionado.observacoes || '',
      });

      setLogData({
        id: itemSelecionado.id,
        usuarioRegistro: itemSelecionado.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          itemSelecionado.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: itemSelecionado.dataRegistro,
        dataAtualizacao: itemSelecionado.dataUltimaAtualizacao,
        nEdicoes: itemSelecionado.nEdicoes,
      });
    }
  };

  //////FUNÇÕES CRUD
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    let novoValor = value;

    const camposCalculo = ['embalagemFator', 'qtdEncomendada'];

    if (camposCalculo.includes(name)) {
      novoValor = formatarNumero(value);

      const fatorEmbalagem =
        name === 'embalagemFator'
          ? novoValor
          : formatarNumero(form.embalagemFator?.toString() || '0');

      const qtdEncomendada =
        name === 'qtdEncomendada'
          ? novoValor
          : formatarNumero(form.qtdEncomendada?.toString() || '0');

      const valorUnitarioDolar = form.valorUnitarioDolar
        ? parseInputMonetario(form.valorUnitarioDolar)
        : tempValorUnitario;

      const cambio = form.cambio
        ? parseInputMonetario(form.cambio)
        : tempCambio;
      console.log(cambio);

      // Remover pontos e converter para número
      const fatorEmbalagemNum =
        parseFloat(fatorEmbalagem.replace(/\./g, '')) || 0;
      const qtdEncomendadaNum =
        parseFloat(qtdEncomendada.replace(/\./g, '')) || 0;

      const qtdEmbalagens = qtdEncomendadaNum / fatorEmbalagemNum;
      const qtdEmbalagensFormatado = formatarNumero(qtdEmbalagens);

      const totalDolares = qtdEncomendadaNum * valorUnitarioDolar;
      const totalReais = cambio * totalDolares;
      const totalFormatadoDolares = formatarValorFormatoDinheiro(totalDolares);
      const totalFormatadoReais = formatarValorFormatoDinheiro(totalReais);

      setForm((prev: OrdemCompraType) => ({
        ...prev,
        [name]: novoValor,
        qtdEmbalagens: qtdEmbalagensFormatado,
        valorTotalDolares: totalFormatadoDolares,
        valorTotalReais: totalFormatadoReais,
      }));
      return;
    }

    setForm((prev: OrdemCompraType) => ({
      ...prev,
      [name]: novoValor,
    }));
  };

  const handleCreate = async () => {
    try {
      if (!validateForm(form)) throw new Error('Formulário inválido.');
      const formToSend = adjustFormBeforeSubmit(form);

      await httpClient.post(`/api/orginter-ordemcompra`, formToSend);
      swalSave();
      fetchMain();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(form)) throw new Error('Formulário inválido.');
      const formToSend = adjustFormBeforeSubmit(form);
      const response = await httpClient.patch(
        `/api/orginter-ordemcompra/${recordId}`,
        formToSend,
      );
      swalAtualizacao('Sucesso', response.data.message);
      fetchMain();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await httpClient.delete(`/api/orginter-ordemcompra/${recordId}`);
      swalDeleteConfirm();
      fetchMain();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  //////OUTRAS FUNÇÕES
  const validateForm = (form: any) => {
    const erros = [];
    if (!form.statusOrdem) erros.push('<b>Status da Ordem</b> é obrigatório.');
    if (!form.numeracaoOrdem)
      erros.push('<b>Numeração da Ordem</b> é obrigatório.');
    if (!form.embalagemFator)
      erros.push('<b>Fator Embalagem</b> é obrigatório.');
    if (!form.qtdEncomendada)
      erros.push('<b>Fator Embalagem</b> é obrigatório.');
    if (!form.dataOrdem) erros.push('<b>Data da Ordem</b> é obrigatório.');

    if (form.statusOrdem > 1) {
      if (!form.dataPrevisao)
        erros.push('<b>Data de Previsão</b> é obrigatório.');
    }
    if (erros.length > 0) {
      swalAttention(erros.join('<br>'));
      return false;
    }
    return true;
  };

  const adjustFormBeforeSubmit = (form: any) => {
    const adjustedForm = {
      ...form,
      orgInterId: Number(form.orgInterId),
      termoRefId: Number(form.termoRefId),
      cotacaoId: form.cotacaoId ? Number(form.cotacaoId) : tempCotacaoId,
      produtoId: form.produtoId ? Number(form.produtoId) : tempProdutoId,
      statusOrdem: Number(form.statusOrdem),
      numeracaoOrdem: form.numeracaoOrdem.trim(),
      embalagemFator: Number(form.embalagemFator.replace(/\./g, '')),
      qtdEncomendada: Number(
        form.qtdEncomendada.replace(/\./g, '').replace(',', '.'),
      ),
      dataOrdem: form.dataOrdem ? new Date(form.dataOrdem) : null,
      dataPrevisao: form.dataPrevisao ? new Date(form.dataPrevisao) : null,

      //Observações
      observacoes:
        form.observacoes === ''
          ? 'Sem observações específicas.'
          : form.observacoes,
    };

    const cleanForm = { ...adjustedForm };
    // Remover campos não desejados
    delete cleanForm.numeracaoReq;
    delete cleanForm.valorUnitarioDolar;
    delete cleanForm.cambio;
    delete cleanForm.valorTotalDolares;
    delete cleanForm.valorTotalReais;

    return cleanForm;
  };

  //////FUNÇÕES FORM COTACAO
  const handleChangeFormCotacao = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;

    if (name === 'cotacaoId') {
      const cotacaoSelecionada = cotacoesData.find(
        (c) => String(c.cotacaoId) === String(value),
      );

      setTempCotacaoId(Number(value));
      setTempCotacaoReq(cotacaoSelecionada?.cotacaoNumeracao || '');
      setTempProdutoId(cotacaoSelecionada?.produtoId || 0);
      setTempValorUnitario(cotacaoSelecionada?.valorUnitario || 0);
      setTempCambio(cotacaoSelecionada?.cambio || 0);

      setFormCotacao((prev) => ({
        ...prev,
        cotacaoId: Number(value),
        cotacaoNumeracao: cotacaoSelecionada?.cotacaoNumeracao || '',
        produtoId: cotacaoSelecionada?.produtoId || 0,
        produtoFarmaceutico: cotacaoSelecionada?.produtoFarmaceutico || '',
        identificacao: cotacaoSelecionada?.identificacao || '',
        valorUnitario: cotacaoSelecionada?.valorUnitario || 0,
        cambio: cotacaoSelecionada?.cambio || 0,
      }));
    }
  };

  const handleClickInserirCotacao = () => {
    handleShowModal();
    handleShowModalFormCotacao();
    handleClearFormCotacao();
  };

  const handleClearFormCotacao = () => {
    setFormCotacao({
      identificacao: '',
      cotacaoId: 0,
      cotacaoNumeracao: '',
      produtoId: 0,
      produtoFarmaceutico: '',
      valorUnitario: 0,
      cambio: 0,
    });
  };

  //USE EFFECT
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const laranja = '#faca71dd';
    const amarelo = '#faffb4dd';
    const azul = '#acbaff';

    const status = String(form.statusOrdem);

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? azul
            : status === '3'
              ? verde
              : status === '4'
                ? laranja
                : status === '5'
                  ? vermelho
                  : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [form.statusOrdem]);

  useEffect(() => {
    const { dataOrdem, dataPrevisao } = form;

    if (dataOrdem && dataPrevisao) {
      const dtOrdem = new Date(dataOrdem);
      const dtPrevisao = new Date(dataPrevisao);

      if (dtPrevisao < dtOrdem) {
        setForm((prev) => ({
          ...prev,
          dataPrevisao: '',
        }));
        swalAttention(
          `A data de <b>ORDEM DA COMPRA</b> ${formatDateSimp(dataOrdem)} <b><span style="color:red">não pode ser anterior</span></b> à data de <b>PREVISÃO</b> ${formatDateSimp(dataPrevisao)}.`,
        );
      }
    }
  }, [form.dataOrdem, form.dataPrevisao]);

  useEffect(() => {
    setForm((prev) => ({ ...prev, produtoId: 0 }));
  }, [isPlanoTrabalho]);

  return (
    <BoxConteudo boxTitulo="Ordem de Compra (APO)">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headersOrdemCompra}
            dataTable={tableData}
            displayValues={valoresExibidosFiscalContrato}
            onRowClick={handleRowClickRow}
            dataOffCanvas={offCanvasData}
            botaoAbrirOffCanvas={false}
            showPagination={false}
            noOffCanvasTable={true}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            setUpdating(false);
            handleClickInserirNovo();
          }}
        />
      </CustomCol>

      {/* Select de Cotação REQ para Ordem de Compra */}
      <Modal
        tituloModal={'Selecionar Cotação'}
        open={showModalFormCotacao}
        onHide={handleShowModalFormCotacao}
        modalSize="medio"
        size="lg"
      >
        <WorkspaceFicha>
          <CustomRow></CustomRow>
          <CustomRow>
            <CustomCol>
              <SelectInput
                name="cotacaoId"
                value={formCotacao.cotacaoId}
                options={cotacoesOptions}
                onChange={handleChangeFormCotacao}
                label="Cotação"
              />
            </CustomCol>
          </CustomRow>

          <BarraInferiorBotoes>
            <WorkspaceBotoes
              inserir
              onClickInserir={handleClickInserirCotacao}
            />
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </Modal>

      {/* Modal Ordem de Compra /*/}
      <Modal
        tituloModal="Registro de Ordem de Compra (APO)"
        open={showModal}
        onHide={handleShowModal}
      >
        <WorkspaceFicha>
          <Log
            {...logData}
            entity="TB_ORG_INTER_ORDEM_COMPRA"
            id={Number(form.id)}
          />
          <BoxConteudo boxTitulo="Ordem de Compra (APO)">
            {/* Identificação da Ordem de Compra */}
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="100px">
                <Input
                  name="cotacaoId"
                  value={form.cotacaoId ? form.cotacaoId : tempCotacaoId}
                  id="cotacaoId"
                  label="ID REQ"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol width="175px">
                <Input
                  name="numeracaoReq"
                  value={form.numeracaoReq ? form.numeracaoReq : tempCotacaoReq}
                  id="numeracaoReq"
                  label="Nº REQ"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol width="250px">
                <Select
                  name="statusOrdem"
                  value={form.statusOrdem}
                  label="Status"
                  options={statusOrdemOptions}
                  onChange={handleChange}
                  style={statusStyle}
                  required
                />
              </CustomCol>

              <CustomCol width="200px">
                <Input
                  id="numeracaoOrdem"
                  name="numeracaoOrdem"
                  value={form.numeracaoOrdem}
                  label="Nº da Ordem de Compra"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            {/* Produto Farmacêutico */}
            <CustomRow>
              <CustomCol width="100px">
                <Input
                  id="produtoId"
                  name="produtoId"
                  value={form.produtoId ? form.produtoId : tempProdutoId}
                  label="ID Produto"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Select
                  name="produtoId"
                  value={form.produtoId ? form.produtoId : tempProdutoId}
                  label="Produto Farmacêutico"
                  options={isPlanoTrabalho ? produtoData : produtoAllData}
                  onChange={handleChange}
                />
              </CustomCol>

              <CustomCol width="150px">
                <CheckboxCustomizado
                  label="Plano de Trabalho"
                  checked={isPlanoTrabalho}
                  onChange={() => setIsPlanoTrabalho(!isPlanoTrabalho)}
                />
              </CustomCol>
            </CustomRow>

            {/* Quantitativo */}
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  id="embalagemFator"
                  name="embalagemFator"
                  value={form.embalagemFator}
                  label="Fator Embalagem"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="qtdEmbalagens"
                  name="qtdEmbalagens"
                  value={form.qtdEmbalagens}
                  label="Total de Embalagens"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  id="qtdEncomendada"
                  name="qtdEncomendada"
                  value={form.qtdEncomendada}
                  label="Quantidade Encomendada"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  id="qtdEntregue"
                  name="qtdEntregue"
                  value={0}
                  label="Quantidade Entregue"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="125px">
                <Input
                  id="qtdEntreguePercentual"
                  name="qtdEntreguePercentual"
                  value={0}
                  label="% Entregue"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            {/* Valores R$ */}
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  id="valorUnitarioDolar"
                  name="valorUnitarioDolar"
                  value={
                    form.valorUnitarioDolar
                      ? form.valorUnitarioDolar
                      : Number(tempValorUnitario).toFixed(2)
                  }
                  label="Valor Unitário (US$)"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="cambio"
                  name="cambio"
                  value={
                    form.cambio ? form.cambio : Number(tempCambio).toFixed(2)
                  }
                  label="Câmbio R$/US$"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="300px">
                <Input
                  id="valorTotalReais"
                  name="valorTotalReais"
                  value={form.valorTotalReais}
                  label="Valor Total R$"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="300px">
                <Input
                  id="valorTotalDolares"
                  name="valorTotalDolares"
                  value={form.valorTotalDolares}
                  label="Valor Total US$"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            {/* Datas */}
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  id="dataOrdem"
                  name="dataOrdem"
                  type="date"
                  value={form.dataOrdem}
                  label="Data da Ordem de Compra"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="dataPrevisao"
                  name="dataPrevisao"
                  type="date"
                  value={form.dataPrevisao}
                  label="Previsão de Entrega"
                  onChange={handleChange}
                  required={form.statusOrdem > 1}
                />
              </CustomCol>
              <CustomCol width="220px">
                <Input
                  id="dataUltimaEntrega"
                  name="dataUltimaEntrega"
                  value={''}
                  label="Última Entrega"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            {/* Observações */}
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  type="textarea"
                  value={form.observacoes}
                  label="Observações"
                  linhas={5}
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
          <BarraInferiorBotoes>
            {updating ? (
              <WorkspaceBotoes
                delete
                // deleteDisabled={btDisable}
                onClickDelete={handleDelete}
                save
                // saveDisabled={btDisable}
                onClickSave={handleUpdate}
              />
            ) : (
              <WorkspaceBotoes
                inserir
                // inserirDisabled={btDisable}
                onClickInserir={handleCreate}
              />
            )}
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </Modal>
    </BoxConteudo>
  );
};

export default OrdemCompra;
